import axios from 'axios';
import { API_URL } from "./constants";

export const loginFunc = async (username, password) => {
    const response = await axios.post(API_URL + "token/", { username, password });
    if (response.data.access) {
        localStorage.setItem("access", response.data.access);
        localStorage.setItem("refresh", response.data.refresh);
    }
    return response.data;
};

export const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
};

export const getAuthHeaders = () => {
    return {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
        },
    };
};

export const forgotPassword = async (email) => {
    const response = await axios.post(API_URL + "auth/forgot-password/", { email });
    return response.data;
};

export const resetPassword = async (uid, token, newPassword) => {
    const response = await axios.post(API_URL + "auth/reset-password/", {
        uid,
        token,
        new_password: newPassword,
    });
    return response.data;
};
